import formatTableJson from '@younuo/config/tableComponentParams.js'
import { YNColor } from '@younuo/config/StateColorEmun'
export default formatTableJson([
  {
    filed: 'account',
    label: '账号'
  },
  {
    filed: 'name',
    label: '真实姓名'
  },
  {
    filed: 'phone',
    label: '手机号'
  },
  {
    filed: 'email',
    label: '邮箱'
  },
  {
    filed: 'state',
    label: '启用状态',
    type: 'tag',
    formatFn: function (_, row) {
      let dic = {
        Y: '启用',
        N: '停用'
      }
      return dic[row.state]
    },
    colorList: YNColor
  }
])
